import React, { useState } from 'react'
import { checkErrors, checkErrorsWhenSubmit, ValuesForm } from '../../../../utils/verifications/Forms';
import { MyYup } from '../../../../utils/verifications/myYup';
import { useTranslation } from 'react-i18next';
import TitleInBorderForInput from '../../../UIcomponents/TitleInBorderForInput/TitleInBorderForInput';
import ButtonSubmitFormINE from '../../../VerifyId/SliderId/SliderIdCard/Forms/ButtonSubmitFormINE/ButtonSubmitFormINE';
import { BodyCedula } from '../../../../utils/requestsUtils/functionsRequests/user/userFunctions';

type FormCedulaProps = {
    onSubmit: (arg: BodyCedula) => void
}

const FormCedula = ({ onSubmit }: FormCedulaProps) => {

    const { i18n } = useTranslation()

    const [inputValues, setInputValues] = useState<ValuesForm>({
        name: { error: "", value: "", touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18n.language, dv).isRequired().isString().justLetters()},
        lastName: { error: "", value: "", touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18n.language, dv).isRequired().isString().justLetters()},
        idCedula: { error: "", value: "", touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18n.language, dv).isRequired().isNumber().min(4)},
    });  

    const handleSubmit = async(e: any) => {
        e.preventDefault()

        let existsError = false;
        for(const nameInput in inputValues){
            if(checkErrorsWhenSubmit(nameInput, inputValues))
                existsError = true
        }
        setInputValues({...inputValues})

        if(existsError)
            return

        onSubmit({
            nombre: inputValues["name"].value, 
            paterno: inputValues["lastName"].value, 
            idCedula: inputValues["idCedula"].value
        })

    }

    return (
        <form onSubmit={handleSubmit}>

            <div className="flex flex-d-column mt-16">
                <div className="con-input padding-to-show-error">
                    <TitleInBorderForInput name={"name"} title={"Name"} />   
                    <input
                        id="name"
                        name="name"
                        type="text"
                        placeholder={"Name"}
                        className="input-modal"
                        onChange={(e: any) => {
                            checkErrors(e, inputValues, setInputValues)
                        }}
                        value={inputValues["name"].value}
                        onFocus={(e:any) => { setInputValues({...inputValues, [e.target.name]: {...inputValues[e.target.name], touched: true}})  }}
                    />
                    { inputValues["name"].error && (
                        <p className="error-input-text">{inputValues["name"].error  || ""}</p>
                    )}
                </div>
            </div>

            <div className="flex flex-d-column mt-16">
                <div className="con-input padding-to-show-error">
                    <TitleInBorderForInput name={"lastName"} title={"Last name"} />   
                    <input
                        id="lastName"
                        name="lastName"
                        type="text"
                        placeholder={"Last name"}
                        className="input-modal"
                        onChange={(e: any) => {
                            checkErrors(e, inputValues, setInputValues)
                        }}
                        value={inputValues["lastName"].value}
                        onFocus={(e:any) => { setInputValues({...inputValues, [e.target.name]: {...inputValues[e.target.name], touched: true}})  }}
                    />
                    { inputValues["lastName"].error && (
                        <p className="error-input-text">{inputValues["lastName"].error  || ""}</p>
                    )}
                </div>
            </div>

            <div className="flex flex-d-column mt-16">
                <div className="con-input padding-to-show-error">
                    <TitleInBorderForInput name={"idCedula"} title={"Id Cedula"} />   
                    <input
                        id="idCedula"
                        name="idCedula"
                        type="text"
                        placeholder={"Id Cedula"}
                        className="input-modal"
                        onChange={(e: any) => {
                            checkErrors(e, inputValues, setInputValues)
                        }}
                        value={inputValues["idCedula"].value}
                        onFocus={(e:any) => { setInputValues({...inputValues, [e.target.name]: {...inputValues[e.target.name], touched: true}})  }}
                    />
                    { inputValues["idCedula"].error && (
                        <p className="error-input-text">{inputValues["idCedula"].error  || ""}</p>
                    )}
                </div>
            </div>

            <ButtonSubmitFormINE onPress={handleSubmit} />

        </form>
    )
}

export default React.memo( FormCedula )